import * as yup from 'yup';

export const programSchema = yup.object().shape({
    title: yup.string()
        .required('Program title is required')
        .min(3, 'Program title must be at least 3 characters')
        .max(255, 'Program title must not exceed 255 characters'),
    description: yup.string()
        .max(1000, 'Description must not exceed 1000 characters')
        .optional(),
    assignedTo: yup.string()
        .max(100, 'Assigned to must not exceed 100 characters')
        .optional(),
    dueDate: yup.string()
        .required('Due date is required'),
});

export const checklistCategorySchema = yup.object({
    name: yup.string()
        .required('Category name is required')
        .min(3, 'Category name must be at least 3 characters')
        .max(50, 'Category name must not exceed 50 characters'),
    description: yup.string()
        .max(200, 'Description must not exceed 200 characters'),
    order: yup.number()
        .required('Order is required')
        .min(0, 'Order cannot be negative')
        .integer('Order must be a whole number'),
});

export const checklistItemSchema = yup.object({
    programId: yup.string()
        .required('Program is required'),
    categoryId: yup.string()
        .required('Category is required'),
    title: yup.string()
        .required('Item title is required')
        .min(3, 'Title must be at least 3 characters')
        .max(100, 'Title must not exceed 100 characters'),
    description: yup.string()
        .max(300, 'Description must not exceed 300 characters'),
    status: yup.string()
        .oneOf(['pending', 'in_progress', 'completed', 'not_applicable'], 'Invalid status')
        .required('Status is required'),
    assignedTo: yup.string(),
    dueDate: yup.date(),
    comments: yup.string()
        .max(500, 'Comments must not exceed 500 characters'),
    order: yup.number()
        .required('Order is required')
        .min(0, 'Order cannot be negative')
        .integer('Order must be a whole number'),
});

export const userSchema = yup.object({
    name: yup.string()
        .required('Name is required')
        .min(2, 'Name must be at least 2 characters')
        .max(50, 'Name must not exceed 50 characters'),
    email: yup.string()
        .email('Invalid email format')
        .required('Email is required'),
    role: yup.string()
        .oneOf(['admin', 'moderator', 'user'], 'Invalid role')
        .required('Role is required'),
});

export interface ProgramFormData {
    title: string;
    description?: string;
    assignedTo?: string;
    dueDate: string;
}

export interface ChecklistCategoryFormData {
    name: string;
    description?: string;
    order: number;
}

export interface ChecklistItemFormData {
    programId: string;
    categoryId: string;
    title: string;
    description?: string;
    status: 'pending' | 'in_progress' | 'completed' | 'not_applicable';
    assignedTo?: string;
    dueDate?: Date;
    comments?: string;
    order: number;
}

export interface UserFormData {
    name: string;
    email: string;
    role: 'admin' | 'moderator' | 'user';
}
